export default __webpack_public_path__ + "static/media/Hamburger_icon_white.9942dd1a.svg";